import {
    ConditionalOperator,
    ConditionalAction,
    DayOfWeek,
    Month,
    TwoMonths,
    Quarter,
    HalfYear,
} from "api/generated/model";
import { CoveredPeriodKey } from "utils/coveredPeriod";

import { TaskType, RecurrenceType } from "./types";

export const METADATA_IDENTIFIER_COLUMN = "ControlProgramName";
export const CONTROL_TAGS_PREFIX = "ControlTags: ";
export const TASK_PREFIX = "Task";
export const FIRST_REVIEWER_TASK_PREFIX = "FirstReviewerTask";
export const SECOND_REVIEWER_TASK_PREFIX = "SecondReviewerTask";
export const MAX_BULK_IMPORT_TASKS = 50;
export const MAX_BULK_IMPORT_REVIEWER_TASKS = 20;
export const FIRST_DATA_ROW = 2;

export const TASK_FIELDS = [
    "Title",
    "Instructions",
    "Type",
    "Options",
    "Required",
    "Condition_ref",
    "Condition_is_or_not",
    "Condition_value",
    "Condition_show_or_hide",
] as const;

export const VALID_TASK_TYPES: Array<TaskType> = [
    "TextInput",
    "TextArea",
    "NumericInput",
    "FileUpload",
    "Heading",
    "RadioButtonGroup",
    "CheckboxGroup",
    "Dropdown",
];

export const TASK_TYPES_REQUIRING_OPTIONS: Array<TaskType> = [
    "RadioButtonGroup",
    "CheckboxGroup",
    "Dropdown",
];

export const CONDITIONAL_REFERENCE_TASK_TYPES: Array<TaskType> = [
    "RadioButtonGroup",
    "CheckboxGroup",
    "Dropdown",
];

export const VALID_DAYS: Array<DayOfWeek> = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
];

export const VALID_MONTHS: Array<Month> = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
] as const;

export const VALID_TWO_MONTHS: Array<TwoMonths> = [
    "JanuaryFebruary",
    "MarchApril",
    "MayJune",
    "JulyAugust",
    "SeptemberOctober",
    "NovemberDecember",
] as const;

export const VALID_QUARTERS: Array<Quarter> = [
    "First",
    "Second",
    "Third",
    "Fourth",
];

export const VALID_HALF_YEARS: Array<HalfYear> = ["First", "Second"];

export const RECURRENCE_TYPES_REQUIRING_OFFSET_DAYS: Array<RecurrenceType> = [
    "Monthly",
    "EveryTwoMonths",
    "Quarterly",
    "HalfYearly",
    "Yearly",
];

export const RECURRENCE_TYPES = [
    "Date",
    "Weekly",
    "Monthly",
    "EveryTwoMonths",
    "Quarterly",
    "HalfYearly",
    "Yearly",
] as const satisfies readonly RecurrenceType[];

export const COVERED_PERIOD_KEYS = [
    "None",
    "CurrentMonth",
    "PreviousMonth",
    "TwoMonthsBeforeDueDate",
    "ThreeMonthsBeforeDueDate",
    "CurrentPeriod",
    "CurrentQuarter",
    "PreviousQuarter",
    "CurrentHalfYear",
    "PreviousHalfYear",
    "CurrentYear",
    "PreviousYear",
    "NextYear",
] as const satisfies readonly CoveredPeriodKey[];

export const CONDITIONAL_OPERATOR_MAP: Record<string, ConditionalOperator> = {
    is: "Equal",
    not: "NotEqual",
};

export const CONDITIONAL_ACTION_MAP: Record<string, ConditionalAction> = {
    show: "Show",
    hide: "Hide",
};
